module.exports = __webpack_public_path__ + "img/category-donation-bg-ocean.2e96a89.webp";